export const COMPLETED_TXN_STATUSES = [
  { label: 'Completed', value: 'completed' },
  { label: 'Approval', value: 'APPROVAL' },
  { label: 'Partially refunded', value: 'partially_refunded' }
];

export const COMPLETED_PAYMENT_STATUSES = [
  ...COMPLETED_TXN_STATUSES,
  { label: 'Finalized', value: 'finalized' }
];

export const REFUNDED_PAYMENT_STATUSES = [
  ...COMPLETED_PAYMENT_STATUSES,
  { label: 'Refunded', value: 'refunded' }
];

export const REPORT_STATUS_OPTIONS = [
  ...REFUNDED_PAYMENT_STATUSES,
  { label: 'Voided', value: 'voided' },
  { label: 'Canceled', value: 'cancelled' }
];

export const REPORT_TRANSACTION_TYPE_OPTIONS = [
  { label: 'Credit card', value: 'credit_card' },
  { label: 'Cash', value: 'cash' },
  { label: 'Check', value: 'check' },
  { label: 'Outside financing', value: 'care_credit' },
  { label: 'Write-off', value: 'writeoff' }
];

export const PAYROC_SETTLEMENT_TYPE_OPTIONS = [
  { label: 'Capture', value: 'capture' },
  { label: 'Return', value: 'return' }
];

export const REPORT_PAYMENT_SOURCE_OPTIONS = [
  { label: 'Paid by patient', value: 'paid by patient' },
  { label: 'Paid by insurance', value: 'paid by insurance' }
];

export const COMPENSATION_MODEL_OPTIONS = [
  { value: 'hourly', label: 'Hourly' },
  { value: 'flat_per_visit', label: 'Flat per visit' },
  { value: 'flat_per_procedure', label: 'Flat per procedure' },
  { value: 'percent_of_charge', label: '% of charge' },
  { value: 'percent_of_allowable', label: '% of allowable' },
  { value: 'percent_of_self_pay', label: '% of self-pay collected' },
  { value: 'percent_of_total_collected', label: '% of total collected' }
];

export const ADJUDICATION_OPTIONS = [
  { label: 'All dates of service', value: 'all' },
  { label: 'Fully adjudicated only', value: 'adjudicated' }
];

// Basis for the Accounts Receivable figure: 'billed' (default) reports gross AR at charged
// amounts; 'allowable' reports the expected collectible AR from the payer's contracted rate.
export const AR_BASIS_OPTIONS = [
  { label: 'Billed amount', value: 'billed' },
  { label: 'Allowable amount', value: 'allowable' }
];
